import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MyBinReportSearchFilter from '../MyBinReportSearchFilter/MyBinReportSearchFilter';
import CustomTable from '../../../../../Components/custom_components/CustomTable/CustomTable';
import CustomModal from '../../../../../Components/custom_components/CustomModal/CustomModal';
import { get_schedule_by_id } from '../../../../../config/Worksite/scheduleApis';
import { addReport } from '../../../../../config/ReportApis/scheduleReportApis';
import { ErrorToast, SuccessToast } from '../../../../../utils/toast';
import ReportAddForm from '../../../Schedule/Components/ReportAddForm/ReportAddForm';
import ReportAssignmentsViewOnly from './ReportAssignmentsViewOnly';
import { hasPrivilege } from '../../../../../utils/privileges';
import { useSelector } from 'react-redux';

function MyBinReportTable() {
    const { scheduleId } = useParams();
    const privileges = useSelector((state) => state.privileges.privileges);

    const [scheduleListing, setScheduleListing] = useState([]);
    const [scheduleInfo, setScheduleInfo] = useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [reportModal, setReportModal] = useState({
        isOpen: false,
        scheduleId: null,
        values: null,
        reportId: null,
    });

    // Fetch schedule reports when scheduleId or refresh changes
    useEffect(() => {
        fetchScheduleReports();
    }, [scheduleId, refresh]);

    const fetchScheduleReports = async () => {
        try {
            setIsLoading(true);
            const response = await get_schedule_by_id({ scheduleID: scheduleId });

            if (response?.status === 'success') {
                setScheduleInfo(response?.data || []);
                setScheduleListing(response?.reports || []);
            } else {
                setScheduleListing([]);
            }
        } catch (error) {
            console.error('Error fetching schedule reports:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Table columns
    const columns = [
        { title: '#', key: 'key' },
        { title: 'Report', key: 'Reportname' },
        { title: 'Current Process', key: 'process' },

        { title: 'Schedule', key: 'ScheduleCode' },
        { title: 'latest_status', key: 'latest_status' },
        { title: 'Technology', key: 'technologyname' },
        { title: 'Worksite', key: 'ScheduleWorksite' },
        { title: 'Submited Date', key: 'submitedDate' },
    ];

    // Map table rows
    const rows = () =>
        scheduleListing?.map((item, index) => ({
            key: index + 1,
            id: item.SHRD_Id,
            Reportname: item.report_name,
            ScheduleCode: item.SD_ScheduleCode,
            process: item.Process?.map((item) => item?.Type),
            submitedDate: item.submitedDate,
            process_status: item.process_status,
            Projectname: item.ProjectName,
            ScheduleWorksite: item.worksite,
        }));

    // Save a new or edited report
    const handleSaveReport = async (formData, id) => {
        try {
            setIsButtonDisabled(true);
            const response = await addReport({ ...formData, scheduleID: id });

            if (response?.status === 'success') {
                setRefresh(prev => !prev);
                handleCloseReportModal();
                SuccessToast(response?.message);
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        } finally {
            setIsButtonDisabled(false);
        }
    };

    // Report modal handlers
    const handleOpenReportModal = (values = null, scheduleId = null, reportId = null) => {
        setReportModal({ isOpen: true, scheduleId, values, reportId });
    };

    const handleCloseReportModal = () => {
        setReportModal({
            isOpen: false,
            scheduleId: null,
            values: null,
            reportId: null,
        });
    };

    // Define the required permission actions
    const PERMISSION_ACTIONS = {
        view: 4,
        edit: 5,
        history: 6,
        add: 3,
        addReport: 9,
        reAssign: 10,
        changeStatus: 11,
        ViewReport: 12,
        changeProcess: 13,
        invoiceOverView: 16
    };
    // Map permissions to boolean values based on privileges
    const userPermissions = {
        view: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.view),
        edit: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.edit),
        ViewReport: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.ViewReport),
        addReport: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.addReport),
        reAssign: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.reAssign),
        changeStatus: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.changeStatus),
        changeProcess: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.changeProcess),
        invoiceOverView: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.invoiceOverView),

    };



    //for schedule Current progress
    const scheduleCurrentProgress = scheduleInfo?.Is_completed || '-'

    const isScheduleCanceled = scheduleInfo?.is_cancel === 1 ? true : false //1 MEANS CANCELED

    const isScheduleStarted = scheduleInfo?.Shedule_process_status !== 0;  //0 MEANS NOT STARTED

    const isScheduleActive = scheduleInfo?.SD_Status === 1 ? true : false //1 ACTIVE CANCELED

    const scheduleStatusText = isScheduleActive ? `Active` : `Inactive`


    return (
        <div className="workforce-management-table-container">
            <MyBinReportSearchFilter
                tableTitle="My Report Bin"
                handleOpenReportModal={handleOpenReportModal}
                scheduleId={scheduleId}

            />

            {/* <CustomTable
                columns={columns}
                rows={isLoading ? [] : rows()}
                isCheckbox={false}
                isLoading={isLoading}
            /> */}


            <ReportAssignmentsViewOnly
                scheduleId={scheduleId}

                reportsData={scheduleListing}
                isLoading={isLoading}
                handleOpenReportModal={handleOpenReportModal}

                isAddReport={!isScheduleCanceled && userPermissions.addReport && isScheduleStarted && isScheduleActive && !scheduleInfo.sentFinance}
                isViewReport={userPermissions?.ViewReport}
            />

            {/* Report Add/Edit Modal */}
            {reportModal.isOpen && (
                <CustomModal
                    open={reportModal.isOpen}
                    handleClose={handleCloseReportModal}
                    title="Add Report"
                    body={
                        <ReportAddForm
                            handleSave={handleSaveReport}
                            isButtonDisabled={isButtonDisabled}
                            scheduleId={scheduleId}
                            isDisabled={false}
                            defaultValues={scheduleInfo}
                        />
                    }
                    maxWidth="800px"
                />
            )}
        </div>
    );
}

export default MyBinReportTable;
